export default "__VITE_ASSET__U8_seT1t__"